// react components
import React, {
    useState,
} from 'react'

// components
import {
    LightboxCustomSite,
} from 'components'

// props
type ImageHelper825Props = {
    alt: string | undefined
    className?: string
    dominant_color: string | undefined
    lightBox?: boolean
    lightBoxSrc?: string
    minHeight?: string
    onClick?: any
    src: string | undefined
}

// main
export const ImageHelper825: React.FC<ImageHelper825Props> = React.memo(({
    alt,
    className,
    dominant_color,
    lightBox,
    lightBoxSrc,
    minHeight,
    onClick,
    src,
}) => {

    const [isLightBoxOpen, setIsLightBoxOpen] = useState(false)
    const [styles, setStyles] = useState<any>({
        backgroundColor: `rgb${dominant_color}`,
        minHeight: minHeight || undefined,
        objectPosition: '-100vw',
    })

    return (
        <React.Fragment>
            <img
                alt={src ? (alt || 'What The Web') : ''}
                className={`${className || ''}`}
                onClick={lightBox ? () => setIsLightBoxOpen(true) : onClick}
                // onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
                onLoad={() => setStyles(undefined)}
                onError={(e: any) => {
                    setStyles({
                        backgroundColor: `rgb${dominant_color}`,
                        minHeight: minHeight || undefined,
                        objectPosition: '-100vw',
                    })
                    e.target.alt = ''
                }}
                src={src}
                style={styles}
            />
            {lightBox && isLightBoxOpen && (
                <LightboxCustomSite
                    mainSrc={lightBoxSrc || src}
                    onCloseRequest={() => setIsLightBoxOpen(false)}
                />
            )}
        </React.Fragment>
    )
})
